<template>
  <v-flex
    xs12
    style="position: relative; width: 100%; float: left"
    class="mt-2"
  >
    <h3 class="pr-4">
      <span v-if="event.taskType === 'Automation'">
        <v-icon class="mr-2" :color=color>play_circle_filled</v-icon>Ran at
      </span>
      <span v-else>
        <v-icon class="mr-2" color="secondary">check_circle</v-icon>Marked as complete at
      </span>
      <span style="font-weight: 500">{{event.causedAt.toLocaleString()}}</span> by
        <UserAvatar          
          status="active"
          :user-id="event.causedById"
          :name="event.causedBy"
          size="34px"
          avatar-only
          class="expansion-avatar mr-2"
        >
        </UserAvatar>
      <span style="color: red" v-if="!event.success"><strong>FAILED</strong></span>
    </h3>
    <code
      v-if="event.logs && event.logs.length > 0"
      style="
        width: 100%;
        float: left;
        max-height: 100px;
        overflow-y: auto;
        box-shadow: 0 0 0 0;
        border-radius: 0;
        white-space: pre-line;
        padding: 10px 20px;
        margin: 5px 0 20px 0;
        font-size: 1rem;
        font-weight: 400;
      "
      class="primary--text"
      >{{logs}}</code
    >
  </v-flex>
</template>


<script>
import UserAvatar from '../../Users/UserAvatar.vue'
export default {
  name: "CaseTaskRunHistoryRow",
  components: {UserAvatar},
  props: { event: { type: Object, required: true } },
  computed: {
    logs() {
      return this.event.logs.map(l => l.message).join("\n")
    },
    color() {
      return this.event.success ? "secondary" : "error"
    }
  }
}
</script>